import React from 'react'
import Dialog from 'material-ui/Dialog'
import Loader from 'react-loader'
import { Link } from 'react-router-dom'
import Recorded from 'material-ui/svg-icons/toggle/radio-button-checked'
import { RaisedButton } from 'material-ui'
import IconButton from 'material-ui/IconButton'
import Clear from 'material-ui/svg-icons/content/clear'
import { CopyLink, EndCall, Plugin, RedirectToBreakout, Settings } from './Modals'
import { MoveModal } from '../BreakOutMode/Modals'

const modalType = (Modal) => {
  const ModalType = (props) => (
    <Dialog
      onRequestClose={props.handleClose}
      contentStyle={{
        width: (props.purpose === 'breakout') ? 430 : '95%'
      }}
      bodyStyle={{
        padding: 0,
        overflowY: 'scroll'
      }}
      open={props.open}>
      {(props.purpose === 'breakout') ? (
        <Modal>
          <RedirectToBreakout
            redirectToBreakoutMode={props.redirectToBreakoutMode}
            handleClose={props.handleClose}/>
        </Modal>
      ) : (props.purpose === 'settings') ? (
        <Modal>
          <Settings
            handleClose={props.handleClose}
            handleDeviceSave={props.handleDeviceSave}
            audio_device={props.audio_device}
            audio_output_array={props.audio_output_array}
            video_device={props.video_device}
            getDeviceList={props.getDeviceList}
            bitrate_index={props.bitrate_index}
            video_device_value_index={props.video_device_value_index}
            audio_device_value_index={props.audio_device_value_index}
            audio_output_device_value_index={props.audio_output_device_value_index}
            changeAudioOutPut={props.changeAudioOutPut}
            disabledVideoPermission={props.disabledVideoPermission}
            disabledAudioPermission={props.disabledAudioPermission}
          />
        </Modal>
      ) : (props.purpose === 'move') ? (
        <Modal>
          <MoveModal
            handleClose={props.handleClose}/>
        </Modal>
      ) : (props.purpose === 'end') ? (
        <Modal>
          <EndCall
            handleClose={props.handleClose}
            hangupConf={props.hangupConf}
          />
        </Modal>
      ) : (props.purpose === 'plugin') ? (
        <Modal>
          <Plugin
            handleClose={props.handleClose}
          />
        </Modal>
      ) : (props.purpose === 'copylink') ? (
        <Modal>
          <CopyLink
            handleClose={props.handleClose}
            pathname={props.pathname}
          />
        </Modal>
      ) : (props.purpose === 'loading') ? (
        <Modal>
          <Loader loaded={false} lines={13} length={20} width={10} radius={30}
                  corners={1} rotate={0} direction={1} color="#000" speed={1}
                  trail={60} shadow={false} hwaccel={false} className="spinner"
                  zIndex={2e9} top="50%" left="50%" scale={1.00}
                  loadedClassName="loadedContent"/>
        </Modal>
      ) : (props.purpose === 'endRecording') ? (
        <Modal>
          <div className="flex justify-end">
            <IconButton onClick={props.handleClose} iconStyle={{fill: '#afb8c5'}}>
              <Clear/>
            </IconButton>
          </div>
          <div className="pa3">
            <div className="flex items-center">
              <Recorded/>
              <div className="ml3">
                <p>録画が終了しました</p>
              </div>
            </div>
            <div className="flex justify-end">
              <Link to="/recordings" target="_blank">
                <RaisedButton
                  label="録画ファイルを見る"
                  onClick={props.handleClose}
                />
              </Link>
            </div>
          </div>
        </Modal>
      ) : props.purpose}
    </Dialog>
  )
  return ModalType
}

export default modalType



// WEBPACK FOOTER //
// ./src/routes/SeminarMode/ModalHOC.js